<template>
    <div class='UtilityLink col-4 offset-4' :class="[ { 'activeMenu': name == menuName } ]" @click="menuOpen(name)">
        <!-- <span class="icon" v-if="name == 'Hammer Icon'" >
            <HammerIcon></HammerIcon>
        </span> -->
        <span class="icon"><HammerIcon></HammerIcon></span>
        <SkuCollector v-if="menuName == name && menuName == 'SKU Collector'"></SkuCollector>
    </div>
</template>
<script>
    import HammerIcon from '../../../icons/HammerIcon.vue';
    import SkuCollector from './SkuCollector.vue';
    export default{
        name: 'UtilityLink',
        props: [ 'name' ],
        components: {
            HammerIcon,
            SkuCollector
        },
        data(){
            return{
                openMenu: false
            }
        },
        computed: {
            menuName(){
                return this.$store.getters['ItemCard/openMenu'];
            }
        },
        methods: {
            menuOpen(name){
                console.log(name);
                if(name == this.menuName){
                     this.$store.commit('ItemCard/setMenu', '');
                }else{
                    this.$store.commit('ItemCard/setMenu', name);
                }
            }
        }
    }
</script>